import React from 'react';
import BooleanInput from '../Form/BooleanInput';
import FormInput from '../Form/FormInput';
import { Container, Row, Col } from 'reactstrap';
import ClientSelector from '../Form/ClientSelector';
import { useEdit } from '../../Services/EditContext';
import ClientDetailsCard from '../Cards/ClientDetailsCard'
import {  useFormikContext } from 'formik';
import { useAuth } from '../../Services/AuthContext';

const ClientDepartmentDetail = ({invite,route }) => {
    //<StringSelector id='catering' label="Catering" list={charterTypes?.catering} />
    //  <BooleanInput id='shared' label='Shared' />
    const { values } = useFormikContext();
    const [auth] = useAuth();
    const [edit] = useEdit();
    return <React.Fragment>
        <Container>
            <Row>
                <Col>
                    {edit ? <ClientSelector id="clientMasterId" label="Client" /> : <ClientDetailsCard route={route} charterDetails={{ client:values.client }}/>}
                </Col>
            </Row>
           
            <Row>
                <Col>
                   
                    <Row>
                        <Col>
                            <FormInput id='departmentName' label='Department Name' />
                        </Col>
                        <Col>
                            <FormInput id='departmentDescription' label='Description' />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormInput id='firstName' label='First Name' />
                        </Col>
                        <Col>
                            <FormInput id='lastName' label='Last Name' />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormInput readOnly={!invite} id='email' label='Email' type='email' />
                        </Col>
                        <Col>
                            <FormInput id='departmentPhone' label='Phone' type='phone' />
                        </Col>
                    </Row>
                    {auth.role ==="Admin"?<Row>
                        <Col>
                            <BooleanInput id='canViewSupplierInfo' label='Can View Supplier Info?' />
                        </Col>
                    </Row>:null}
                    <Row>
                        <Col>
                            <BooleanInput id='itineraryShowPrice' label='Show price in itinerary?' />
                        </Col>
                        
                        <Col>
                            <FormInput id='itineraryMinutesOffset' label="Itinerary Departure Time offset" type='number' />
                        </Col>
                        <Col>
                            <BooleanInput id='itineraryHidePhone' label='Hide Phone numbers in itinerary?' />
                        </Col>
                        <Col>
                            <BooleanInput id='itineraryShowSupplier' label='Show Supplier details in itinerary?' />
                        </Col>
                    </Row>

                </Col>
            </Row>
        </Container>


    </React.Fragment>
};

export default ClientDepartmentDetail;

